export default __webpack_public_path__ + "static/media/3.dbca5daa.svg";